<template>
    <b-modal
        body-class="p-0"
        hide-footer
        id="no-dates-available-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
                Unfortunately there are currently no dates available this week
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">
            <!-- Request hasn't been sent -->
            <template v-if="!requestSent">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(onSubmit)">

                        <p>
                            If you would like to be added to our waiting list, please fill out your details below and a member of our team will contact you either later this week, if a slot becomes available, or on Monday to arrange a repair for next week.
                        </p>

                        <div class="form-group">
                            <ValidationProvider name="Full name" rules="required" v-slot="{ errors }">
                                <label>Full name <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="contactDetail['name']" type="text" :class="{'is-invalid': errors[0]}">
                                <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
                                <label>Email address <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="contactDetail['email']" type="email" :class="{'is-invalid': errors[0]}">
                                <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <ValidationProvider name="Telephone number" rules="required" v-slot="{ errors }">
                                <label>Telephone number <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="contactDetail['phonenumber']" type="tel" :class="{'is-invalid': errors[0]}">
                                <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                            </ValidationProvider>
                        </div>

                        <button class="btn btn-block continue-btn btn-lg" type="submit" v-if="!requestSending">Request Call-back</button>
                        <button class="btn btn-block continue-btn btn-lg" v-if="requestSending" disabled><animated-loading size="xs" class="mr-1"></animated-loading> Sending request...</button>
                    </form>
                </ValidationObserver>
            </template>

            <!-- Request has been sent -->
            <template v-if="requestSent">
                <empty-state
                    class="pt-0"
                    statusIcon="success"
                    title="Thank you for your interest"
                    subtitle="A member of the Likewize Repair team will contact you as soon as a slot becomes available"
                ></empty-state>
                <div class="btn btn-secondary btn-block" @click="closeRequestModal()">{{ $t('bp.closeButton') }}</div>
            </template>
        </div>
    </b-modal>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import { extend } from 'vee-validate';

extend('required', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true
});

export default {
    name: "NoDatesAvailableModal",

    data() {
        return {
            contactDetail: {
                email: null,
                name: null,
                phonenumber: null,
            },
            requestSending: false,
            requestSent: false
        }
    },

    computed: {
        ...mapGetters(['activeModelVersionId', 'booking', 'carrier', 'reference'])
    },

    methods: {
        ...mapActions(['requestCallBackForNoDates']),

        /** Close the modal and clear the fields */
        closeRequestModal() {
            this.$bvModal.hide('no-dates-available-modal');
            setTimeout(() => {
                this.requestSent = false;
                this.contactDetail.name = null;
                this.contactDetail.email = null;
                this.contactDetail.phonenumber = null;
            }, 200)
        },

        /** Send the request */
        onSubmit() {
            event.preventDefault();

            if (this.requestSending) return;

            this.requestSent = false;
            this.requestSending = true;

            this.requestCallBackForNoDates({
                modelVersionId: this.activeModelVersionId,
                postcode: this.booking.address.postcode,
                name: this.contactDetail.name,
                email: this.contactDetail.email,
                phone: this.contactDetail.phonenumber,
                carrier: this.carrier
            }).then(() => {
                this.requestSent = true;
                this.requestSending = false;

            }).catch(() => {
                this.requestSent = false;
                this.requestSending = false;
            });
        }
    }
}
</script>

<style scoped>

</style>